export enum POLICIES {
	CAR = 'CAR',
	DOG = 'DOG',
	HORSE = 'HORSE',
	HOUSE = 'HOUSE',
	HOLIDAY_HOUSE = 'HOLIDAY_HOUSE',
	TRAVEL = 'TRAVEL',
	MOPED = 'MOPED',
	ACCIDENT = 'ACCIDENT',
	TRAILER = 'TRAILER',
	BOAT = 'BOAT',
	CONTENT = 'CONTENT',
	CARAVAN = 'CARAVAN',
	MOTORCYCLE = 'MOTORCYCLE',
}

export enum PROPOSAL_STEPS {
	previousBlock = 'previousBlock',
	summaryBlock = 'summaryBlock',
	consentBlock = 'consentBlock',
	receiptBlock = 'receiptBlock',
}

export enum POLICY_FIELDS {
	cover_start_date = 'cover_start_date',
	cancelExistingPolicy = 'cancelExistingPolicy',
	cancelExistingPolicyText = 'cancelExistingPolicyText',
	payment_method = 'payment_method',
	payment_frequency = 'payment_frequency',
	reg_no = 'reg_no',
	account = 'account',
	previous_company_id = 'previous_company_id',
	mileage = 'mileage',
	mileage_date = 'mileage_date',
	previous_policy_id = 'previous_policy_id',
	termination_option = 'termination_option', // formerly takeover_date
	consent_summary = 'consent_summery',
	total_fees = 'total_fees',
	total_price = 'total_price',
	product_price_template = 'product_price_template',
	product_affinity_header_template = 'product_affinity_header_template',
	product_affinity_template = 'product_affinity_template',
	total_claims_for_this_insurance_type = 'total_claims_for_this_insurance_type',
	claims_insurance_template = 'claims_insurance_template',
	insurance_type = 'insurance_type',
}

export enum UNDERWRITING_QUESTIONS_FIELDS {
	registered_on_rki = 'registered_on_rki',
	terminated_by_previous_company = 'terminated_by_previous_company',
	canceled_due_to_non_payment = 'canceled_due_to_non_payment',
	had_stricter_terms = 'had_stricter_terms',
	total_claims = 'total_claims',
}

export enum UNDERWRITING_TEXT_FIELDS {
	claims_text = 'claims_text',
	total_claims_text = 'total_claims_text',
}

export enum INPUT_TYPES {
	TextField = 'TextField',
	TextOnlyField = 'TextOnlyField',
	NumberField = 'NumberField',
	DatePickerField = 'DatePickerField',
	RadioButtonField = 'RadioButtonField',
	CheckField = 'CheckField',
	TextSearchField = 'TextSearchField',
	DropDownField = 'DropDownField',
	AddressSearchField = 'AddressSearchField',
}
